var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200.00000000000003,
    height: 261.5565462660339,
    viewBox: "0 0 200.00000000000003 261.5565462660339",
    className: "css-1j8o68f",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs1039"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient1042"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop1043",
    stopColor: "#7f00ff",
    offset: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "0;0.2;0.5",
    dur: "1.5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop1044",
    stopColor: "#e100ff",
    offset: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "0.5;0.7;0.8;1",
    dur: "1.5s",
    repeatCount: "indefinite"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1040",
    featurekey: "nameFeature-0",
    transform: "matrix(9.341483398442808,0,0,9.341483398442808,-14.950334705545448,-112.09905691263768)",
    fill: "url(#SvgjsLinearGradient1042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.01 20.688 c0 1.9432 -0.65408 3.8078 -1.8158 5.3116 c1.162 1.504 1.8161 3.3685 1.8161 5.3116 c0 4.7908 -3.8974 8.6884 -8.6884 8.6884 l-2.2625 0 c-0.58252 0 -1.1411 -0.23141 -1.5529 -0.64316 l-8.2628 -8.2628 c-0.85784 -0.85756 -0.85756 -2.248 0 -3.1056 s2.248 -0.85756 3.1056 0 l7.6196 7.6196 l1.3528 0 c2.3688 0 4.296 -1.9274 4.296 -4.296 c0 -1.3956 -0.6838 -2.7096 -1.829 -3.5156 c-0.58468 -0.4112 -0.93252 -1.0813 -0.93252 -1.7961 s0.34781 -1.3849 0.93252 -1.7961 c1.1452 -0.80568 1.829 -2.12 1.829 -3.5156 c0 -2.3688 -1.9274 -4.296 -4.296 -4.296 l-8.3289 0 l0 3.9768 l7.6192 7.6196 c0.85784 0.85756 0.85784 2.248 0 3.1056 c-0.85756 0.85784 -2.248 0.85784 -3.1056 0 l-8.2628 -8.2628 c-0.41176 -0.41176 -0.64316 -0.9704 -0.64316 -1.5529 l0 -7.0824 c0 -1.2128 0.98328 -2.196 2.196 -2.196 l10.525 0 c4.7908 0 8.6884 3.8974 8.6884 8.6884 z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.efb3465389e546ff1fb477caf76af5f8.svg";
export { ForwardRef as ReactComponent };